import { render, staticRenderFns } from "./SuccessfullyReceived.vue?vue&type=template&id=1fbdb10a&scoped=true"
import script from "./SuccessfullyReceived.vue?vue&type=script&lang=js"
export * from "./SuccessfullyReceived.vue?vue&type=script&lang=js"
import style0 from "./SuccessfullyReceived.vue?vue&type=style&index=0&id=1fbdb10a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbdb10a",
  null
  
)

export default component.exports